export default class CookieManager {
    setCookie(name, content, expireDays, path = null) {
        let date = new Date;
        date.setDate(date.getDate() + expireDays);

        document.cookie = `${name}=${encodeURIComponent(content)}; path=${path}; expires=${date.toUTCString()}`;
    }

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}